import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let cutOffLine = class cutOffLine extends Vue {
  constructor() {
    super(...arguments);
    this.text = "";
  }
  dataChage(value) {
    this.text = value.text;
    console.log(this.text, "图片预览组件---", value);
  }
};
__decorate([Prop({
  type: Object,
  default: {}
})], cutOffLine.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], cutOffLine.prototype, "dataChage", null);
cutOffLine = __decorate([Component({
  name: "cutOffLine"
})], cutOffLine);
export default cutOffLine;